// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ActionLink from '../../../../shared/components/action-link';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import Popover from '../../../../shared/components/popover/popover';
import ProductSearchResultAction from './product-search-action';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasAccess} from '../../../../shared/services/security';
import {hasPermission} from '../../../../shared/services/privacy';

const ProductSearchResultPopover = (props, context) => {

    const security = context.security;

    const privacy = context.user.privacy;

    const popoverTarget = (
        <button className='actions-popover-button'>
            <FormattedMessage id='ACTIONS'/>
        </button>
    );

    const popoverContent = (
        <ul>
            {hasAccess(security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(privacy, 'registrationNotAllowed') &&
                <li>
                    <ProductSearchResultAction
                        label='REGISTER_PRODUCT'
                        link={`/products/register-product?pin=${props.pin}`}
                        statusList={props.statusList}
                    />
                </li>
            }
            {hasAccess(security, 'PRT', 'PRT_STATUS_CHANGE') &&
                <li>
                    <Link
                        to={`/products/status-change-request/${props.pin}`}
                    >
                        <FormattedMessage id='UPDATE_MACHINE_STATUS'/>
                    </Link>
                </li>
            }
            {hasAccess(security, 'CLAIM', 'CLM_CLAIM_CREATE') &&
                <li>
                    <ActionLink
                        isDisabled={false}
                        label={<FormattedMessage id='CREATE_CLAIM'/>}
                        onClick={props.onClaimsModalOpen.bind(null, props.pin)}
                        type='button-link'
                    />
                </li>
            }
            {hasAccess(security, 'PRT', 'PRT_DEALER_TRANSFER') &&
                <li>
                    <ProductSearchResultAction
                        label='CHANGE_RESPONSIBLE_DEALER'
                        link={`/products/new-transfer/${props.pin}`}
                        statusList={props.statusList}
                    />
                </li>
            }
            <li>
                <ProductSearchResultAction
                    label='VIEW_OPEN_PIPS'
                    link={`/pips/search?by=PIN&q=${encodeURIComponent(props.pin)}`}
                    statusList={props.statusList}
                />
            </li>
        </ul>
    );

    return (
        <Popover
            content={popoverContent}
            target={popoverTarget}
        />
    );

};

ProductSearchResultPopover.displayName = 'ProductSearchResultPopover';
ProductSearchResultPopover.propTypes = {
    onClaimsModalOpen: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    statusList: PropTypes.array.isRequired
};
ProductSearchResultPopover.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ProductSearchResultPopover;



// WEBPACK FOOTER //
// ./src/product/search/components/product-search-popover/index.js